export default {
  title: 'Połącz {asset} ze źródłem danych',
};
